export class Config {
  UI_VERSION: string;
}

export const CONFIG: any = {
  UI_VERSION: 'v0.7.5',
};
